import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  IconButton,
  TextField,
  Button,
  Divider,
  Link as MuiLink,
} from "@mui/material";
import {
  Facebook,
  Instagram,
  Twitter,
  YouTube,
  LinkedIn,
  Email,
  ArrowForward,
} from "@mui/icons-material";
import { Link } from "react-router-dom";

// Images
import googlePlay from "../Images/google.png";
import appleStore from "../Images/apple.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "background.paper",
        pt: 10,
        pb: 4,
        borderTop: "1px solid",
        borderColor: "divider",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={8}>
          {/* Column 1: About */}
          <Grid item xs={12} md={5}>
            <Box sx={{ mb: 4 }}>
              <Typography variant="body1" sx={{ color: "text.secondary", lineHeight: 1.8, mb: 4 }}>
                The DataTech Labs Inc cloud-based learning platform helps you cultivate a culture of personalized, learner-driven, and social learning to ensure your organization is prepared for the future.
              </Typography>
              <Box sx={{ display: "flex", gap: 1 }}>
                {[
                  { icon: <Facebook />, link: "#" },
                  { icon: <Instagram />, link: "#" },
                  { icon: <Twitter />, link: "#" },
                  { icon: <YouTube />, link: "#" },
                  { icon: <LinkedIn />, link: "#" },
                ].map((social, i) => (
                  <IconButton
                    key={i}
                    component="a"
                    href={social.link}
                    sx={{
                      color: "text.secondary",
                      "&:hover": { color: "#D4AF37", bgcolor: "rgba(212, 175, 55, 0.1)" },
                    }}
                  >
                    {social.icon}
                  </IconButton>
                ))}
              </Box>
            </Box>
          </Grid>

          {/* Column 2: Quick Links */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" fontWeight={700} gutterBottom sx={{ mb: 3 }}>
              Quick Links
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              {[
                { text: "Privacy Policy", path: "privacy" },
                { text: "Terms & Conditions", path: "terms" },
                { text: "About Us", path: "about" },
                { text: "Contact Support", path: "contact" },
              ].map((link, i) => {
                const isAdmin = window.location.pathname.includes('/db-shiksha/kaas/admin');
                const prefix = isAdmin ? '/db-shiksha/kaas/admin/' : '/db-shiksha/kaas/student/';
                return (
                  <MuiLink
                    key={i}
                    component={Link}
                    to={`${prefix}${link.path}`}
                    sx={{
                      color: "text.secondary",
                      textDecoration: "none",
                      fontWeight: 500,
                      transition: "color 0.3s ease",
                      "&:hover": { color: "#D4AF37" },
                    }}
                  >
                    {link.text}
                  </MuiLink>
                );
              })}
            </Box>
          </Grid>

          {/* Column 3: Newsletter */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" fontWeight={700} gutterBottom sx={{ mb: 3 }}>
              Stay Updated
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Subscribe to our newsletter for the latest course updates and news.
            </Typography>
            <Box component="form" sx={{ display: "flex", gap: 1, mb: 4 }}>
              <TextField
                placeholder="Email Address"
                size="small"
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": { borderRadius: "50px" },
                }}
              />
              <IconButton
                type="submit"
                sx={{
                  bgcolor: "#D4AF37",
                  color: "black",
                  "&:hover": { bgcolor: "#B8860B" },
                }}
              >
                <ArrowForward fontSize="small" />
              </IconButton>
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Box component="img" src={googlePlay} sx={{ height: 35, cursor: "pointer" }} />
              <Box component="img" src={appleStore} sx={{ height: 35, cursor: "pointer" }} />
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ mt: 8, mb: 3 }} />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © {currentYear} KaaS. All rights reserved.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Powered by{" "}
            <MuiLink
              href="https://thedatatechlabs.com/"
              target="_blank"
              sx={{ color: "#D4AF37", textDecoration: "none", fontWeight: 600 }}
            >
              The DataTech Labs Inc
            </MuiLink>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
